<template>
  <p class="text-negative q-mt-sm">
    <span class="text-weight-bold">Action required:</span>
    <span class="text-weight-medium">
      There is no deal setting found between
      {{ buyerName }}
      <span v-if="buyerGstin"> (GSTIN: {{ buyerGstin }}) </span>

      and
      {{ sellerName }}

      <span v-if="sellerGstin"> (GSTIN: {{ sellerGstin }}) </span>
      . Please contact the KAM to set up a deal for this trade before
      proceeding.
    </span>
  </p>
</template>

<script setup>
defineProps({
  buyerName: {
    type: String,
    default: "",
  },
  buyerGstin: {
    type: String,
    default: "",
  },
  sellerName: {
    type: String,
    default: "",
  },
  sellerGstin: {
    type: String,
    default: "",
  },
});
</script>
